import React, { Suspense } from 'react';
import Grid from '@mui/material/Grid';
import Tabs from '@mui/material/Tabs';
import { shape } from 'prop-types';
import { Preloader } from '#component/preloader';
import createLabelWithIcon from '#component/icon/label-icons';
import DeviceEvents from '#component/device/overview/events/index';
import SidebarDevices from '#component/sidebar/devices/index';
import Timeline from './timeline';
import ShipmentInfo from './shipment-info';
import { TabCnt, TabBar, StyledTab, TabContentCnt, Divider } from './styles';

const TIMELINE_TAB = 0;
const DEVICES_TAB = 1;
const EVENTS_TAB = 2;
const INFO_TAB = 3;

const ShipmentTimeline = ({
  shipment,
  events,
  shipment: { delivery = [] } = {},
  account = {},
  handleClick,
  handleHover,
  handleTimelineClick,
  handleTimelineHover,
  handleEventGroupHover,
  handleEventGroupClosing,
  isMobile,
  eventsLoading,
  identifiersMap,
  tabSelected,
  setTabSelected,
  sidebarDevicesProps,
  syncSelectedDevicesWithStore
}) => {
  const handleChange = (event, newValue) => {
    setTabSelected(parseInt(newValue, 10));
  };

  const identifiersList = Object.entries(identifiersMap);

  return (
    <Grid item xs={12} style={{ height: '100%' }}>
      <>
        <TabCnt>
          <TabBar position="static" color="default" elevation={0}>
            <Tabs value={tabSelected} variant="scrollable" onChange={handleChange}>
              {identifiersList.map(el => {
                const [i, identifier] = el;
                const index = parseInt(i, 10);
                const isActive = index === tabSelected;
                const label = createLabelWithIcon(
                  identifier,
                  isActive,
                  identifiersList.length > 1,
                  sidebarDevicesProps
                );
                return (
                  <StyledTab
                    value={index}
                    title={identifier}
                    key={identifier}
                    label={label}
                  />
                );
              })}
            </Tabs>
          </TabBar>
          <Divider />
        </TabCnt>
        <TabContentCnt>
          {tabSelected === EVENTS_TAB &&
            (!eventsLoading ? (
              <Suspense fallback={<Preloader />}>
                <DeviceEvents
                  events={events}
                  account={account}
                  isMobile={isMobile}
                  handleEventClick={handleClick}
                  handleEventHover={handleHover}
                  handleEventGroupHover={handleEventGroupHover}
                  handleEventGroupClosing={handleEventGroupClosing}
                  syncSelectedDevicesWithStore={syncSelectedDevicesWithStore}
                />
              </Suspense>
            ) : (
              <Preloader />
            ))}
          {tabSelected === DEVICES_TAB && (
            <SidebarDevices {...sidebarDevicesProps} />
          )}
          {tabSelected === TIMELINE_TAB && (
            <Timeline
              isMobile={isMobile}
              account={account}
              delivery={delivery}
              shipment={shipment}
              handleClick={handleTimelineClick}
              handleHover={handleTimelineHover}
            />
          )}
          {tabSelected === INFO_TAB && (
            <ShipmentInfo
              isMobile={isMobile}
              shipment={shipment}
            />
          )}
        </TabContentCnt>
      </>
    </Grid>
  );
};

ShipmentTimeline.propTypes = {
  account: shape({})
};

export default ShipmentTimeline;
